import $ from 'jquery';
window.$ = window.jQuery = $;
window.tippy = require('tippy.js').default;
require('slick-carousel');
require('magnific-popup');
window.inputmask = require('inputmask/dist/jquery.inputmask.min').default;

tippy('[data-tippy-content]',{
    theme: 'tippy',

});

const template = document.getElementById('height_template');

tippy('.room__price-height__link', {
    content: template.innerHTML,
    theme: 'ad',
    allowHTML: true,
    arrow: false,
    interactive: true,
    trigger: 'click'
});

$(document).ready(function () {

    function hideBody() {
        $('html, body').css('overflow', 'hidden');
    }

    function clearBodyStyle() {
        $('html, body').removeAttr('style');
    }

    function openModal(el) {
        $(el).show();
        hideBody();
    }

    function closeModal(el) {
        $(el).hide();
        clearBodyStyle();
    }

    $(document).on('click', '.header__humburger', function () {
        openModal('.popup')
    });

    $(document).on('click','.popup__close', function () {
       closeModal('.popup')
    });

});
